import React from 'react';

import { withAssetPrefix } from 'gatsby';

import { MotionPlayer } from '@af/design-system-docs-ui/motion-player';
import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading/heading';
import { Grid } from '@atlaskit/primitives/compiled/grid';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	root: {
		/* Single column on mobile, two columns from 30rem up. */
		gridTemplateColumns: '1fr',
		'@media (min-width: 30rem)': {
			gridTemplateColumns: '1fr 1fr',
		},
		paddingBlockStart: token('space.400'),
		paddingBlockEnd: token('space.400'),
	},
});

/**
 * Grid of motion-property `MotionPlayer`s with labels and descriptions.
 */
const MotionProperties = (): React.JSX.Element => {
	return (
		<Grid testId="grid-basic" rowGap="space.150" columnGap="space.150" xcss={styles.root}>
			<Stack space="space.100">
				<MotionPlayer
					source="lottie"
					lottieSrc={withAssetPrefix('/lottie/foundations/motion/scale.json')}
					size="small"
					hasSpacing={false}
					label="Two stacked rectangles scaling up to illustrate the scale property"
				/>
				<Heading size="small">Scale</Heading>
				<Text>Growing or shrinking in size.</Text>
			</Stack>
			<Stack space="space.100">
				<MotionPlayer
					source="lottie"
					lottieSrc={withAssetPrefix('/lottie/foundations/motion/fade.json')}
					size="small"
					hasSpacing={false}
					label="Three rectangles fading from opaque to transparent to illustrate the fade property"
				/>
				<Heading size="small">Fade</Heading>
				<Text>Changing opacity.</Text>
			</Stack>
			<Stack space="space.100">
				<MotionPlayer
					source="lottie"
					lottieSrc={withAssetPrefix('/lottie/foundations/motion/slide.json')}
					size="small"
					hasSpacing={false}
					label="A rectangle sliding in from the right edge of its container to the left edge to illustrate the slide property"
				/>
				<Heading size="small">Slide</Heading>
				<Text>Moving along the X or Y axis.</Text>
			</Stack>
			<Stack space="space.100">
				<MotionPlayer
					source="lottie"
					lottieSrc={withAssetPrefix('/lottie/foundations/motion/colour.json')}
					size="small"
					hasSpacing={false}
					label="A rectangle changing color to illustrate the color property"
				/>
				<Heading size="small">Color</Heading>
				<Text>Transitioning between background or border colors.</Text>
			</Stack>
		</Grid>
	);
};

export default MotionProperties;
